import { FC, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import CustomLink from '../../../../../common/custom-link';
import Routes from '../../../../../constants/routes';
import { ReactComponent as GreyHeart } from '../../../../../images/icon-heart_.svg';
import translation, { world } from '../../../../../languages';
import { AVAILABLE_WORLDS } from '../../../../../languages/constants';
import { getFavorite, getSchoolWishlist } from '../../../../../reducers/favorite';
import cn from '../../../../../utils/classnames';
import { domainLinkCreator } from '../../../../../utils/domain-manager';
import schoolAccount from '../../../../../utils/school-account';
import './favorites-btn.scss';

type FavoritesBtnProps = TranslationProps & {
    getFavorite: typeof getFavorite;
    getSchoolWishlist: typeof getSchoolWishlist;
};

const FavoritesBtn: FC<FavoritesBtnProps> = ({ getFavorite, getSchoolWishlist, t }) => {
    const favorite = useSelector((state: RootState) => state.main.favorite);
    const user = useSelector((state: RootState) => state.main.user);
    const isActiveNavigationAbTest = useSelector(
        (state: RootState) => state.main.schoolClassification.isActiveNavigationAbTest
    );
    const isSchoolMember =
        schoolAccount.hasSchool(user) && world === AVAILABLE_WORLDS.DE && !schoolAccount.isAdmin(user);
    const isSchoolWishlist = schoolAccount.isAdmin(user) && world === AVAILABLE_WORLDS.DE;

    useEffect(() => {
        getFavorite();
    }, []);

    useEffect(() => {
        if (isSchoolMember) {
            getSchoolWishlist();
        }
    }, [isSchoolMember]);

    return (
        <div className={cn('d-flex justify-content-center align-items-center header-favorites-btn')}>
            <div>
                <CustomLink
                    className='d-flex flex-column align-items-center justify-content-between'
                    to={domainLinkCreator(isSchoolWishlist ? Routes.SCHOOL_WISHLIST.path : Routes.FAVORITES.path)}
                >
                    <div
                        className={cn('heart-wrapper position-relative', { empty: !favorite.total })}
                        data-amount={favorite.total}
                    >
                        <GreyHeart />
                    </div>
                    <div className={cn('d-none d-lg-block', { 'tsc-caption': isActiveNavigationAbTest })}>
                        {isSchoolWishlist
                            ? t('header.userMenu.authorizedMenuLinks.settings.schoolWishlist')
                            : t('header.icons.favorite')}
                    </div>
                </CustomLink>
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            getFavorite,
            getSchoolWishlist
        },
        dispatch
    );

const translate = translation('header');

export default connect(() => ({}), mapDispatchToProps)(translate(FavoritesBtn));
